import axios from 'axios';
import { ENDPOINTS } from './ENDPOINTS';

export const PageBuilderServices = {

    addPBDetails: async (data) => {
        try {
            const response = await axios.post(ENDPOINTS.PB_DETAILS, data);
            return response.data;
        } catch (error) {
            console.error("Error creating page build:", error);
            throw error;
        }
    },
    getAllPage: async () => {
        try {
            const response = await axios.get(ENDPOINTS.PB_DETAILS);
            return response.data;
        } catch (error) {
            console.error("Error creating page build:", error);
            throw error;
        }
    },
    updatePBDetails: async (id, data) => {
        try {
            const response = await axios.put(`${ENDPOINTS.PB_DETAILS}/${id}`, data);
            return response.data;
        } catch (error) {
            console.error("Error creating page build:", error);
            throw error;
        }
    },
    deletePBDetails: async (id) => {
        try {
            const response = await axios.delete(`${ENDPOINTS.PB_DETAILS}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error in delete page build:", error);
            throw error;
        }
    },
    getPBDetialById: async (id) => {
        try {
            const response = await axios.get(`${ENDPOINTS.PB_DETAILS}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error creating page build:", error);
            throw error;
        }
    },
   
    // page builder

    pbc_insert: async (payload) => {
        try {
            const response = await axios.post(ENDPOINTS.PB_CONTENTS, payload);
            return response.data;
        } catch (error) {
            console.error("Error creating page build:", error);
            throw error;
        }
    },
    pbc_seo_insert: async (payload) => {
        try {
            const response = await axios.post(ENDPOINTS.PB_CONTENTS_SEO, payload);
            return response.data;
        } catch (error) {
            console.error("Error creating page build:", error);
            throw error;
        }
    },
    pbc_get_by_slug: async (id) => {
        try {
            const response = await axios.get(`${ENDPOINTS.PB_CONTENTS}/${id}`,);
            return response.data;
        } catch (error) {
            console.error("Error creating page build:", error);
            throw error;
        }
    },
    pbc_seo_by_slug: async (id) => {
        try {
            const response = await axios.get(`${ENDPOINTS.PB_CONTENTS_SEO}/${id}`,);
            return response.data;
        } catch (error) {
            console.error("Error creating page build:", error);
            throw error;
        }
    },

}